module.exports = __webpack_public_path__ + "static/media/chevron_left.ae42e1a4.svg";